import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"
import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area"
import { useGetList, useRedirect } from "ra-core"

const ArticleCard: React.FC = () => {
  const redirect = useRedirect()

  const { data: blogs } = useGetList("blogs", {
    pagination: { page: 1, perPage: 6 },
    sort: { field: "created_at", order: "DESC" },
  })
  return (
    <>
      <div className="container w-full pt-8  pb-12">
        <div className="bg-muted flex w-full flex-col gap-6 rounded-lg md:rounded-xl lg:flex-row lg:items-center lg:p-12 md:p-8 sm:p-8 xs:p-4">
          <div className="flex-1">
            <h3 className="m-4 text-3xl font-bold md:text-4xl">
              Ready to Build Responsibly ?
            </h3>
            <p className="m-4 text-muted-foreground max-w-xl lg:text-lg">
              Lorem ipsum dolor, sit amet consectetur adipisicing elit. Dolorem
              accusamus molestias eaque magnam officia cumque ratione error
              optio, sequi veniam placeat .
            </p>
          </div>
          <div className="flex shrink-0 flex-col gap-4 sm:flex-row. m-4">
            <Button disabled variant="outline">
              AI Assessment Tool
            </Button>
            <Button
              variant="default"
              size="lg"
              onClick={() => {
                redirect("/projects/create")
              }}
            >
              Start a Project
            </Button>
          </div>
        </div>
      </div>
      <h4 className="scroll-m-20 text-l font-semibold tracking-tight mb-2">
        Learning Materials
      </h4>
      <ScrollArea className="w-full whitespace-nowrap pb-12">
        <div className="flex w-full space-x-4">
          {blogs?.map(item => (
            <div
              onClick={() => redirect(`blogs/${item.id}/show`)}
              className="bg-card text-card-foreground overflow-hidden rounded-lg border w-100 mb-6"
            >
              <img
                src={item.image}
                alt={item.title}
                width={400}
                height={225}
                className="h-68 w-full object-cover"
              />
              <div className="grid gap-2 p-4">
                <h3 className="text-lg leading-tight font-semibold">
                  {item.title.trim().length > 43
                    ? item.title.slice(0, 43) + "..."
                    : item.title}
                </h3>
                <p className="text-muted-foreground line-clamp-3 text-sm">
                  {item.content.trim().length > 55
                    ? item.content.slice(0, 55) + "..."
                    : item.content}
                </p>
                <div className="text-muted-foreground flex items-center gap-2 text-sm">
                  <Avatar className="h-6 w-6">
                    <AvatarImage src={"/placeholder.svg"} />
                    <AvatarFallback>
                      {"Asma Ferchichi"
                        .split(" ")
                        .map(n => n[0])
                        .join("")}
                    </AvatarFallback>
                  </Avatar>
                  <span>Asma Ferchichi</span>
                  <span>•</span>
                  <span>3 min read</span>
                </div>
              </div>
            </div>
          ))}
        </div>
        <ScrollBar orientation="horizontal" />
      </ScrollArea>

      <h4 className="scroll-m-20 text-l font-semibold tracking-tight mb-3">
        Events
      </h4>
      <ScrollArea className="w-full whitespace-nowrap">
        <div className="flex w-full space-x-4">
          {events.map(event => (
            <Card
              key={event.title}
              className="overflow-hidden transition-all hover:shadow-xl inter-var w-100 pt-0 mb-6"
            >
              <img
                src={event.image}
                alt={event.title}
                width="400"
                height="200"
                className="w-full h-56 object-cover"
                style={{ aspectRatio: "400/200", objectFit: "cover" }}
              />
              <CardContent className="p-2 space-y-2">
                <div className="flex items-center justify-between">
                  <h3 className="text-sm font-bold">{event.title}</h3>
                </div>
                <div className="flex items-center space-x-2 text-muted-foreground">
                  <CalendarDaysIcon className="h-5 w-5" />
                  <span>June 15, 2024</span>
                </div>
                <div className="flex items-center space-x-2 text-muted-foreground">
                  <ClockIcon className="h-5 w-5" />
                  <span>9:00 AM - 5:00 PM</span>
                </div>
                <div className="flex items-center space-x-2 text-muted-foreground">
                  <MapPinIcon className="h-5 w-5" />
                  <span>{event.location}</span>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
        <ScrollBar orientation="horizontal" />
      </ScrollArea>
    </>
  )
}

const events = [
  {
    title: "Sustainable Architecture in Mediterranean Climate",
    location: "Online",
    host: "Yassine Ben Ali",
    image:
      "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=2070",
    link: "https://example.com/event1",
  },
  {
    title: "Modern Residential Design Workshop",
    location: "Tunis, Tunisia",
    host: "Leila Mansour",
    image:
      "https://plus.unsplash.com/premium_photo-1723572007898-09ace4ff4b5f?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDI0fHx8ZW58MHx8fHx8&auto=format&fit=crop&q=60&w=900",
    link: "https://example.com/event2",
  },
  {
    title: "Historic Building Restoration Techniques",
    location: "Sfax, Tunisia",
    host: "Karim Gharbi",
    image:
      "https://plus.unsplash.com/premium_photo-1664474578613-3c0a7de53bfd?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDIxfHx8ZW58MHx8fHx8&auto=format&fit=crop&q=60&w=900",
    link: "https://example.com/event3",
  },
  {
    title: "Urban Planning & Smart Cities",
    location: "Sousse, Tunisia",
    host: "Nadia Trabelsi",
    image:
      "https://plus.unsplash.com/premium_photo-1664476731323-b420da926da1?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1pbi1zYW1lLXNlcmllc3wxfHx8ZW58MHx8fHx8&auto=format&fit=crop&q=60&w=900",
    link: "https://example.com/event4",
  },
  {
    title: "Sustainable Materials in Contemporary Design",
    location: "Monastir, Tunisia",
    host: "Sarah Bouazizi",
    image:
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=2070",
    link: "https://example.com/event5",
  },
  {
    title: "Digital Tools in Architectural Design",
    location: "Hammamet, Tunisia",
    host: "Anis Mejri",
    image:
      "https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=2072",
    link: "https://example.com/event6",
  },
]

function CalendarDaysIcon(props: any) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M8 2v4" />
      <path d="M16 2v4" />
      <rect width="18" height="18" x="3" y="4" rx="2" />
      <path d="M3 10h18" />
      <path d="M8 14h.01" />
      <path d="M12 14h.01" />
      <path d="M16 14h.01" />
      <path d="M8 18h.01" />
      <path d="M12 18h.01" />
      <path d="M16 18h.01" />
    </svg>
  )
}

function ClockIcon(props: any) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
  )
}

function MapPinIcon(props: any) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
      <circle cx="12" cy="10" r="3" />
    </svg>
  )
}
export default ArticleCard
